// --- capInitial

export default function capInitial ([ first, ...rest ]) {
    return first
        ? first.toUpperCase() + rest.join( "" )
        : ""
}